import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ContainerModal = styled.div`
  background: var(--background-color);
  display: grid;
  padding: 20px;
  place-items: start;
  border-radius: 4px;
  gap: 20px;
`;

export const LogDetailsItem = styled.div`
  color: var(--color);
  & p {
    color: var(--color);
    line-height: 1.2;
    width: 80ch;
  }
`;

export const SubTitle = styled.h3`
  font-size: 2rem;
  color: var(--color);
  padding: 10px 0;
`;

export const Title = styled.h1`
  font-size: 3.2rem;
  margin-bottom: 2rem;
  color: var(--color);
`;

export const Button = styled(Link)`
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  gap: 5px;
  background: var(--success);
  padding: 7px 10px;
  margin-bottom: 10px;
  font-family: 'GothamBold';
  font-size: 1.4rem;
  color: #fff;
  cursor: pointer;
  text-transform: uppercase;
  transition: 0.3s;
  box-shadow: var(--box-shadow);
  &:hover {
    background: var(--success-hover);
  }
`;
